import { configureStore } from '@reduxjs/toolkit';
import stepReducer from '../reducers/step';
import stepsReducer from '../reducers/steps';
import subscriptionReducer from '../reducers/subscription';
import brewingMethodsReducer from '../reducers/brewingMethods';
import statesReducer from '../reducers/states';
import citiesReducer from '../reducers/cities';
import coffeesReducer from '../reducers/coffees';
import loadingReducer from '../reducers/loading';
import loginModalReducer from '../reducers/loginModal';
import shippingModalReducer from '../reducers/shippingModal';
import referrerReducer from '../reducers/referrer';
import voucherReducer from '../reducers/voucher';
import productsReducer from '../reducers/products'

export default configureStore({
  reducer: {
    step: stepReducer,
    steps: stepsReducer,
    subscription: subscriptionReducer,
    brewingMethods: brewingMethodsReducer,
    states: statesReducer,
    cities: citiesReducer,
    coffees: coffeesReducer,
    loading: loadingReducer,
    loginModal: loginModalReducer,
    shippingModal: shippingModalReducer,
    referrer: referrerReducer,
    voucher: voucherReducer,
    products: productsReducer,
  },
})
